module.exports = __webpack_public_path__ + "img/confirm_2.bd4a0902.svg";